import type { FaireProductEntity } from "../../entity_types/product";

export const p_v64hau4u7h: FaireProductEntity = {
  token: "p_v64hau4u7h",
  type: "product",
  name: "Women's Soft Luxe Robe with Set-In Waist",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/408471ffddfaea614cde2c44be6dfdd9516ac4086a7926fa5f50d2b7ceddf212.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19e6046aacdd6d1fca7b2230b169eb661debd7dd0db913bc7815f1dc0cfa7b5d.jpeg",
    "https://cdn.faire.com/fastly/69fecc8da7833707f51203088406e6e304c21a7d328f22811183286a4667e3e9.jpeg",
    "https://cdn.faire.com/fastly/72261d161172c0bf096c5214585945a252d9fb9e1b64b280d7eac33764c86c7b.jpeg",
    "https://cdn.faire.com/fastly/4811c4130e848abb157f08cdf3718f18c3e1cbe9167a73f7f4ebed1e1720e102.jpeg",
    "https://cdn.faire.com/fastly/98db191d5518b6a4d3379450dc5e26805fb94f6e15a4225d13dd8845993687d3.png",
    "https://cdn.faire.com/fastly/6251d381c5525b6c471447832a9bfdbd1fc7ad99860add27c01b7e762725d853.png",
    "https://cdn.faire.com/fastly/e3787606eeb8d23359ebab6a06f55a6d0a6e912bbaffa4182059420fcbcc8d77.png",
    "https://cdn.faire.com/fastly/76113afd2e38aa9cb751a2dce0b7fc31bb4303337a3bddb4e126c345f2cb7f12.jpeg",
    "https://cdn.faire.com/fastly/ef1720b350c576d1c825433b656311e6cefad1fd2f6cefe5522de322324e73f0.jpeg",
    "https://cdn.faire.com/fastly/4319d777c143fa1e906e9215050ecadfa7b1262317155800cb4af4b6ab75edf9.jpeg",
    "https://cdn.faire.com/fastly/8ab745c5e38725a599f0da94977fb1750e1375e32c271960f2f1847b74de5306.png",
    "https://cdn.faire.com/fastly/beb4f7b43525ba45f14eec37ce6aacda1742e3b390cb2a6fc76c664b610a440a.jpeg",
    "https://cdn.faire.com/fastly/a5c1d247efec9b1556a64fd71bb190a599a9d53440a5259630bef507d7dd2559.jpeg",
    "https://cdn.faire.com/fastly/06761fe5bde563957dce6f05da8e8793c84feb42128e7e3df4b9677969ad7c02.jpeg",
    "https://cdn.faire.com/fastly/98ee2a55164da96834a67c2b970ee27c49a5c2caf5b9268524349a520dc76279.png"
  ],
  priceDollars: 60,
  description: "Perfect warmth without weight, our Serenity Shear Mink Wrap Robe is the perfect fit. It's ultra-plush fabric is a comfortable yet stylish way to relax. For morning coffee on the balcony or for late night warmth, this versatile robe exceeds your comfort needs. This robe also features a super-soft attached belt and an inner satin ribbon you can tie for complete coverage and great fit.\n\nFeatures:\n- Shear mink blend provides lightweight yet comfortable warmth\n- 48” femme robe with attached belt and set-in waist\n- Shawl collar, satin inside tie\n- Side seam pockets",
  tags: [],
  msrpDollars: 130,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:06.870Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
